export default __webpack_public_path__ + "static/media/Tunic of Deadly Guile.46f187b0.jpg";